// v1-only runtime constants: the method-invocation arg shapes, the OAuth header the v1 service reads
// tokens from, and the service-class constructor type used by the ServerCode registration seam.

export type MethodRequestArgumentsMap = Record<string, unknown>
export type MethodRequestArgumentsList = unknown[]

export const OAUTH_ACCESS_TOKEN_HEADER = 'oauth-access-token'

export type ServiceClassType = new (...args: unknown[]) => object;
